import { OrganizationDetail } from '@shared/model/organization';
import { useMemo } from 'react';
import { EditFormKeys } from '../config/form-constants';

export const useNormalizeInitialValues = (values?: OrganizationDetail) => {
    const initialValues = useMemo(() => {
        if (!values) {
            return {
                [EditFormKeys.BankName]: undefined,
                [EditFormKeys.BankPaymentAccount]: undefined,
                [EditFormKeys.BankCorrespondentAccount]: undefined,
                [EditFormKeys.BankBIK]: undefined,
                [EditFormKeys.Catalogs]: [],
            };
        }

        return {
            [EditFormKeys.BankName]: values?.bankName,
            [EditFormKeys.BankPaymentAccount]: values?.bankAccountNumber,
            [EditFormKeys.BankCorrespondentAccount]: values?.correspondentNumber,
            [EditFormKeys.BankBIK]: values?.bik,
            [EditFormKeys.Catalogs]:
                values?.catalogs?.map((product) => ({
                    label: product.name,
                    value: String(product.id),
                })) || [],
        };
    }, [values]);
    return initialValues;
};
